/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Asset,
    AssetFromJSON,
    AssetToJSON,
    ContentItem,
    ContentItemFromJSON,
    ContentItemToJSON,
    ServiceLink,
    ServiceLinkFromJSON,
    ServiceLinkToJSON,
} from './';

/**
 *
 * @export
 * @interface ServiceJourneyStep
 */
export interface ServiceJourneyStep {
    /**
     *
     * @type {string}
     * @memberof ServiceJourneyStep
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ServiceJourneyStep
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof ServiceJourneyStep
     */
    description: string;
    /**
     *
     * @type {Asset}
     * @memberof ServiceJourneyStep
     */
    icon: Asset;
    /**
     *
     * @type {Array<ContentItem>}
     * @memberof ServiceJourneyStep
     */
    articles?: ContentItem[];
    /**
     *
     * @type {Array<ServiceLink>}
     * @memberof ServiceJourneyStep
     */
    serviceLinks?: ServiceLink[];
}

export function ServiceJourneyStepFromJSON(json: any): ServiceJourneyStep {
    return ServiceJourneyStepFromJSONTyped(json, false);
}

export function ServiceJourneyStepFromJSONTyped(json: any, _: boolean): ServiceJourneyStep {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'title': json['title'],
        'name': json['name'],
        'description': json['description'],
        'icon': AssetFromJSON(json['icon']),
        'articles': !exists(json, 'articles') ? undefined : ((json['articles'] as any[]).map(ContentItemFromJSON)),
        'serviceLinks': !exists(json, 'service_links') ? undefined : ((json['service_links'] as any[]).map(ServiceLinkFromJSON)),
    };
}

export function ServiceJourneyStepToJSON(value?: ServiceJourneyStep | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'title': value.title,
        'name': value.name,
        'description': value.description,
        'icon': AssetToJSON(value.icon),
        'articles': value.articles === undefined ? undefined : ((value.articles as any[]).map(ContentItemToJSON)),
        'service_links': value.serviceLinks === undefined ? undefined : ((value.serviceLinks as any[]).map(ServiceLinkToJSON)),
    };
}
